var sc = sc || {};
sc.alpine = sc.alpine || {};

sc.alpine.form = function () {
    return {
        modelState: {},
        hasError(key) {
            var field = this.modelState[key];
            if (field) {
                return field.Errors.length !== 0;
            }
            return false;
        },
        hasRequiredError(key) {
            var field = this.modelState[key];
            if (field) {
                return field.Errors.length !== 0 && field.Errors[0].ErrorMessage.includes('required');
            }
            return false;
        },
        hasOtherError(key) {
            var field = this.modelState[key];
            if (field) {
                return field.Errors.length !== 0 && !this.hasRequiredError(key);
            }
            return false;
        },
        message(key) {
            var field = this.modelState[key];
            if (field) {
                if (field.Errors.length !== 0) {
                    return field.Errors[0].ErrorMessage;
                }
            }
            return '';
        },
        clear(key, event) {
            console.log(event.keyCode);
            if (event.keyCode !== 9) { // TAB key 
                this.modelState[key] = null;
            }
        },
        async submitEnd(event) {
            if ((event.target).isSameNode(this.$el)) {
                var response = event.detail.formSubmission.result.fetchResponse.response;
                if (response.status === 422) {
                    var json = await response.json();
                    this.modelState = json;
                }
            }
        },
        async validate(event) {
            if (event.target.hasAttribute('name')) { // only clientside validate elements with a name attribute
                var val = event.target.value;
                this.$fetch({
                    url: this.$el.action,
                    method: 'post',
                    headers: { 'clientside-validation': '' },
                    data: new FormData(this.$el)
                }).then((res) => {
                    // if the value has changed don't show the validation message as it could be wrong or cause a flash as the message is shown and hidden
                    if (val === event.target.value) {
                        var name = event.target.getAttribute('name');
                        this.modelState[name] = res.data[name];
                    }
                });
            }
        }
    }
}